import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { toast } from 'sonner'
import { Send } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Field } from '@/components/ui/field'
import { contactSchema, type ContactSchema } from '@/lib/schemas'
import { useSubmitContact } from '@/lib/hooks'

export function ContactForm() {
  const form = useForm<ContactSchema>({
    resolver: zodResolver(contactSchema),
    mode: 'onBlur',
  })
  const submit = useSubmitContact()

  async function onSubmit(values: ContactSchema) {
    try {
      await submit.mutateAsync(values)
      toast.success('Message sent — we will reply within one business day.')
      form.reset()
    } catch (err) {
      const e = err as { message?: string }
      toast.error(e.message ?? 'Failed to send. Please try again.')
    }
  }

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4" noValidate>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Your Name" required error={form.formState.errors.name?.message}>
          <Input {...form.register('name')} placeholder="Full name" />
        </Field>
        <Field label="Email" required error={form.formState.errors.email?.message}>
          <Input type="email" {...form.register('email')} placeholder="you@example.com" />
        </Field>
      </div>
      <Field label="Subject" required error={form.formState.errors.subject?.message}>
        <Input {...form.register('subject')} placeholder="What is your inquiry about?" />
      </Field>
      <Field label="Message">
        <Textarea {...form.register('message')} placeholder="Tell us how we can help…" rows={5} />
      </Field>
      <Button type="submit" disabled={submit.isPending} className="self-start">
        {submit.isPending ? 'Sending…' : (<><Send className="h-4 w-4" /> Send Message →</>)}
      </Button>
    </form>
  )
}
